import React from "react";
import { Facebook, Twitter, Instagram, Linkedin, Github, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
export default function MarketplaceFooter() {
  const quickLinks = [{
    label: "Professional Medical",
    href: "/ProfessionalMedicalPage"
  }, {
    label: "Massage & Baby Care",
    href: "/MassageBabyCarePage"
  }, {
    label: "Intimate Wellness",
    href: "/IntimateWellnessPage"
  }, {
    label: "Wellness Guides",
    href: "/WellnessGuidesPage"
  }];
  const supportLinks = [{
    label: "Customer Support",
    href: "#"
  }, {
    label: "View Cart",
    href: "/CartPage"
  }, {
    label: "Checkout",
    href: "/CheckoutPage"
  }, {
    label: "Privacy Policy",
    href: "#"
  }];
  const socialLinks = [{
    icon: Facebook,
    label: "Facebook",
    href: "#"
  }, {
    icon: Twitter,
    label: "Twitter",
    href: "#"
  }, {
    icon: Instagram,
    label: "Instagram",
    href: "#"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    href: "#"
  }, {
    icon: Github,
    label: "GitHub",
    href: "#"
  }];
  return <footer data-section-id="12323" id="footer" className="dark bg-secondary text-secondary-foreground py-16 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592322/img/code_master_94_logo.png" alt="okfun wellness" className="h-7 w-auto object-contain brightness-110" />
            </Link>
            <p className="text-secondary-foreground/70 text-sm leading-relaxed max-w-xs">
              okfun specializes in high-quality health, medical, and personal wellness products. We blend clinical precision with lifestyle aesthetics to support your well-being.
            </p>
            <div className="flex items-center gap-2 text-sm text-secondary-foreground/60">
              <MapPin className="size-4 shrink-0 text-primary" />
              <span>Wellness Plaza, New York, NY</span>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold text-secondary-foreground tracking-wide text-base uppercase">Shop Categories</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200 inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold text-secondary-foreground tracking-wide text-base uppercase">Support</h3>
            <ul className="space-y-3">
              {supportLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-secondary-foreground/70 hover:text-primary transition-colors duration-200 inline-block">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold text-secondary-foreground tracking-wide text-base uppercase">Stay Connected</h3>
            <p className="text-sm text-secondary-foreground/70">
              Join the okfun community for the latest wellness guides and exclusive product releases.
            </p>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => <Button key={i} data-index={i} variant="outline" size="icon" asChild className="rounded-full border-white/10 bg-white/5 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300">
                  <Link to={social.href} aria-label={social.label} newTab>
                    <social.icon className="size-4" />
                  </Link>
                </Button>)}
            </div>
            <div className="pt-2">
               <Link to="mailto:care@okfun.com" className="inline-flex items-center gap-2 text-sm text-secondary-foreground/70 hover:text-primary transition-colors">
                  <Mail className="size-4" />
                  <span>care@okfungo.com</span>
               </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-white/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-secondary-foreground/50">
          <p>&copy; {new Date().getFullYear()} okfun. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-secondary-foreground transition-colors">Privacy</Link>
            <Link to="#" className="hover:text-secondary-foreground transition-colors">Terms</Link>
            <Link to="#" className="hover:text-secondary-foreground transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>;
}